module.exports = __webpack_public_path__ + "static/media/picto-certification.2d65db12.svg";